import React, { Component, Fragment } from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  InputGroup,
  InputGroupAddon
} from 'shards-react';
import { addCategory, addSectors, deleteItem } from '../adminActions';

const mapState = (state, ownProps) => ({
  user: state.firebase.profile,
  categories: state.firebase.ordered.categories,
  sector: ownProps.sector || '',
  dbsectors: state.firebase.ordered.sectors,
  queried: state.firestore.ordered.queried || []
});

const actions = {
  addSectors,
  deleteItem,
  addCategory
};

class AddCategories extends Component {
  state = {
    sector: '',
    category: '',
    input: ''
  };

  handleSector = async e => {
    e.preventDefault();
    console.log(e.target.value);
    this.setState({ [e.target.name]: e.target.value });
    //this.props.firestore.get({ collection: 'sectors', doc: e.target.value, storeAs: 'queried' });
    //console.log(this.props.sectors);
  };

  render() {
    const handleChange = e => {
      this.setState({ [e.target.name]: e.target.value.toLowerCase() });
    };
    const handleSubmit = e => {
      e.preventDefault();

      let category = {
        sector: this.state.sector,
        name: this.state.input
      };

      this.props.addCategory(category);

      this.setState({ category: '', input: '' });
    };

    const {
      dbsectors,

      categories,
      deleteItem
    } = this.props;
    return (
      <Card>
        <CardHeader className='bg-primary1 text-white'>Categories</CardHeader>
        <CardBody className='category-list'>
          {categories &&
            categories.map(category => {
              return (
                <div
                  key={category.key}
                  className='text-capitalize w-100 caption'
                >
                  {category.value.sector} - {category.value.name}
                  <MdClose
                    className='float-right text-danger'
                    onClick={() => deleteItem('categories/', category.key)}
                  />
                </div>
              );
            })}
        </CardBody>

        <CardFooter className='border-top'>
          <Form>
            <FormGroup>
              <label htmlFor='sector'>Select Sector</label>
              <FormSelect
                name='sector'
                onChange={e => this.handleSector(e)}
                value={this.state.sector}
              >
                <option key='0' value='' />
                {dbsectors &&
                  dbsectors.map(sector => (
                    <Fragment>
                      <option key={sector.key} value={sector.value}>
                        {sector.value}
                      </option>
                    </Fragment>
                  ))}
              </FormSelect>
            </FormGroup>

            <FormGroup>
              <InputGroup>
                <FormInput
                  name='input'
                  onChange={handleChange}
                  value={this.state.input}
                />
                <InputGroupAddon type='append'>
                  <Button theme='success' onClick={handleSubmit}>
                    Submit
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </FormGroup>
          </Form>
        </CardFooter>
      </Card>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firebaseConnect([
    {
      path: '/categories',
      queryParams: ['orderByChild=sector'],
      storeAs: 'categories'
    }
  ])
)(AddCategories);
